import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  margin-bottom: 27px;
  position: relative;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  ${mediaMaxWidth.phone`
    margin-bottom: 25px;
  `}
`;

export const Input = styled.input`
  padding: 12px 15px;
  font-size: 1.1em;
  font-weight: 600;
  border: none;
  color: #402680;
  width: calc(100% - 30px);
  outline: ${(props) =>
    props.isError ? "2px solid #79D9D9" : "2px solid transparent"};
  outline-offset: 0px;
  transition: 0.1s ease-in-out;
  font-family: Komet;

  &:disabled {
    outline: 2px solid #ababab;
    color: #ababab;
  }

  &:focus {
    outline: ${(props) =>
      props.isError ? "2px solid #79D9D9" : "2px solid #8064d4"};
  }

  ::placeholder {
    color: ${(props) => (props.isError ? "#888" : "#402680")};
    font-weight: 100;
    font-weight: 300;
  }

  ${mediaMaxWidth.phone`
    padding: 12px;
    font-size: 1em;
    width: calc(100% - 24px);
  `}
`;

export const Error = styled.div`
  position: absolute;
  bottom: -20px;
  width: 100%;
  text-align: center;
  font-size: 0.82em;
  font-weight: 600;
  color: #79D9D9;
`;
